export default {
  profile: 'Profile',
  profileDescription: 'Update your personal information',
  yourProfileWasSaved: 'Your profile was saved',
  twoFactorAuthentication: 'Two factor authentication',
  twoFactorDescription:
    'Two factor authentication (2FA) adds an additional layer of protection beyond passwords',
  twoFactorNowYouMustConfirm: 'You you must confirm the code from your app',
  twoFactorEnabled: 'Two factor authenticacion has been enabled',
  enableTwoFactor: 'Enable two factor authentication',
  twoFactorStep1: '1. Download the TWo Factor app from the AppStore or PlayStore',
  twoFactorStep2: '2. Scan the QR code with the app',
  twoFactorOrManuallyAddTheCode: 'Or manually add the code',
  twoFactorStep3: '3. Write the 6 digit code to confirm',
  twoFactorDisabled: 'Two factor authentication has been disabled correctly',
  twoFactorActivated: 'La autentificación de dos factores esta activada',
  twoFactorYourAccountIsSafer: 'Your account is safer',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmTheNewPassword: 'Confirm the new password',
  confirmYourPassword: 'Confirm your password',
  repeatYourNewPassword: 'Repeat your new password',
  changePassword: 'Change password',
  changePasswordDescription: 'Change your password',
  title: 'Settings',
  security: 'Security'
}
